import { render, staticRenderFns } from "./ActionByLinkDelegationOrderDecisionView.vue?vue&type=template&id=24244a74&scoped=true&"
import script from "./ActionByLinkDelegationOrderDecisionView.vue?vue&type=script&lang=js&"
export * from "./ActionByLinkDelegationOrderDecisionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24244a74",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24244a74')) {
      api.createRecord('24244a74', component.options)
    } else {
      api.reload('24244a74', component.options)
    }
    module.hot.accept("./ActionByLinkDelegationOrderDecisionView.vue?vue&type=template&id=24244a74&scoped=true&", function () {
      api.rerender('24244a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/action-by-link/delegation-order/ActionByLinkDelegationOrderDecisionView.vue"
export default component.exports